export default __webpack_public_path__ + "static/media/signature.94afe769.svg";